import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../api/axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  const storeSession = useCallback((data, profile) => {
    localStorage.setItem('access_token', data.access);
    localStorage.setItem('refresh_token', data.refresh);
    setUser(profile);
    localStorage.setItem('user', JSON.stringify(profile));
    return profile;
  }, []);

  const login = useCallback(async (username, password) => {
    const { data } = await api.post('/auth/login/', { username, password });
    localStorage.setItem('access_token', data.access);
    localStorage.setItem('refresh_token', data.refresh);
    const profile = await api.get('/auth/profile/');
    return storeSession(data, profile.data);
  }, [storeSession]);

  const googleLogin = useCallback(async (credential) => {
    const { data } = await api.post('/auth/google/', { credential });
    return storeSession(data, data.user);
  }, [storeSession]);

  const register = useCallback(async (formData) => {
    await api.post('/auth/register/', formData);
    return login(formData.username, formData.password);
  }, [login]);

  const logout = useCallback(() => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, googleLogin, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
